module.exports = __webpack_public_path__ + "static/listener2-2f891cdb571918fc483f39bbdc825e2b.jpg";